var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCrossGray9Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F39DF232-32F9-4810-A37A-92E7C50AEC78_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-787.000000, -699.000000)",
    stroke: "#C1C1C1",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(752.000000, 392.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(36.000000, 301.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Cross_Gray-9px",
    transform: "translate(0.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L9,9",
    id: "Path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,0 L1.42108547e-14,9",
    id: "Path-6"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrossGray9Px);
export default __webpack_public_path__ + "static/media/Icon_Cross_Gray-9px.6b3fa0880443a4f4f39d5888fc55ffc8.svg";
export { ForwardRef as ReactComponent };